module.exports = __webpack_public_path__ + "img/aditya-saxena-_mIXHvl_wzA-unsplash.268f1662.jpg";